import React from 'react';
import { Region } from '@enonic/react-components';

export default (props) => (
    <div className="container my-4">
        <Region name="main" regionData={props.regionsData.main} />
    </div>
);
